import React, { useState, useEffect } from 'react';
import './topnav.css';
import { FaUserShield, FaUserTie } from 'react-icons/fa'; // Importing icons

const TopNav = () => {
    const [userRole, setUserRole] = useState(''); // State to hold either 'Admin' or 'Provider'

    useEffect(() => {
        // Retrieve and decode admin_id from session storage
        const encodedAdminId = sessionStorage.getItem('admin_id');
        const adminId = encodedAdminId ? atob(encodedAdminId) : null;

        // Determine user role based on the presence of admin_id
        setUserRole(adminId ? 'Admin' : 'Provider');
    }, []);

    return (
        <div className='topnav'>
            {/* Conditionally render greeting with icons based on user role */}
            <a href="/" style={{ textDecoration: 'none' }}>
    <h1 style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        {userRole === 'Admin' ? (
            <>
                <FaUserShield size={30} style={{ color: '#4e73df', marginRight: '15px' }} />
                <span className="greeting-text" style={{ fontSize: '18px' }}>Hello, Admin</span>
            </>
        ) : (
            <>
                <FaUserTie size={30} style={{ color: '#4e73df', marginRight: '15px' }} />
                <span className="greeting-text" style={{ fontSize: '18px' }}>Hello, Provider</span>
            </>
        )}
    </h1>
</a>

        </div>
    );
};

export default TopNav;
